"use client";

import SliderAutoPlay from "@ui/components/composers/SliderAutoPlayWrapper";

export type LogoConfig = {
  height: number;
  width: number;
  src: string;
  alt: string;
};

export const DEFAULT_LOGOS: LogoConfig[] = [
  { height: 40, width: 100, src: "/assets/contact-sales/revolut-white.svg", alt: "Revolut" },
  { height: 40, width: 163, src: "/assets/contact-sales/klarna-white.svg", alt: "Klarna" },
  { height: 40, width: 80, src: "/assets/contact-sales/deutsche-telekom-white.svg", alt: "T-Mobile" },
  { height: 40, width: 110, src: "/assets/contact-sales/meta-white.svg", alt: "Meta" },
  { height: 40, width: 191, src: "/assets/contact-sales/walt-disney-studios-white.svg", alt: "Walt Disney Studios" },
  { height: 40, width: 117, src: "/assets/contact-sales/salesforce-white.svg", alt: "Salesforce" },
];

export function LogoSlider({ logos }: { logos: LogoConfig[] }) {
  const items = logos.map((logo, index) => (
    <div key={index} className='tw-flex tw-items-center tw-justify-center tw-px-6'>
      <div
        className='tw-w-auto tw-bg-white tw-transition-colors'
        style={{
          height: logo.height,
          width: logo.width,
          mask: `url(${logo.src}) center / contain no-repeat`,
          WebkitMask: `url(${logo.src}) center / contain no-repeat`,
        }}
        role='img'
        aria-label={logo.alt}
      />
    </div>
  ));

  return (
    <div className='tw-w-full tw-overflow-hidden tw-flex tw-items-center'>
      <SliderAutoPlay
        items={items}
        startScrollingAt={0}
        className='tw-w-full tw-flex tw-items-center'
        sliderItemClassName='tw-w-1/3 sm:tw-w-1/4 md:tw-w-1/5 lg:tw-w-1/4 xl:tw-w-1/5'
      />
    </div>
  );
}
